import { render, staticRenderFns } from "./TakipEtiketiPicker.vue?vue&type=template&id=0f18c720"
import script from "./TakipEtiketiPicker.vue?vue&type=script&lang=ts"
export * from "./TakipEtiketiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports